import { render, staticRenderFns } from "./report-nuoveauto.vue?vue&type=template&id=170e1786&scoped=true"
import script from "./report-nuoveauto.vue?vue&type=script&lang=js"
export * from "./report-nuoveauto.vue?vue&type=script&lang=js"
import style0 from "./report-nuoveauto.vue?vue&type=style&index=0&id=170e1786&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e1786",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VDataTable,VIcon,VRow,VTextField})
